import $ from 'jquery';
import magnificPopup from 'magnific-popup';

var jsModalIframe = $('.js-modal-iframe');
var jsModalInline = $('.js-modal-inline, a[href^="#modal-"]');
var jsModalImage = $('.js-modal-image');

if (jsModalIframe.length) {
	jsModalIframe.each(function () {
		$(this).magnificPopup({
			type: 'iframe',
		})
	})
}

if (jsModalInline.length) {
	jsModalInline.each(function () {
		$(this).magnificPopup({
			type: 'inline',
			removalDelay: 200,
			callbacks: {
				beforeOpen: function() {
				this.st.mainClass = 'mfp-zoom-in';
				}
			},
		})
	})
}

if (jsModalImage.length) {
	jsModalImage.each(function () {
		$(this).magnificPopup({
			type: 'image',
			removalDelay: 200,
			callbacks: {
				beforeOpen: function() {
				this.st.mainClass = 'mfp-zoom-in';
				}
			},
			image: {
				markup: '<div class="mfp-figure mfp-with-anim">'+
							'<div class="mfp-close"></div>'+
							'<div class="mfp-img"></div>'+
							'<div class="mfp-bottom-bar">'+
							'<div class="mfp-title"></div>'+
							'<div class="mfp-counter"></div>'+
							'</div>'+
						'</div>'
			}
		})
	})
}
